import { render } from "./DemandForecastingTop.vue?vue&type=template&id=0865bd90&scoped=true"
import script from "./DemandForecastingTop.vue?vue&type=script&lang=js"
export * from "./DemandForecastingTop.vue?vue&type=script&lang=js"

import "./DemandForecastingTop.vue?vue&type=style&index=0&id=0865bd90&lang=scss&scoped=true"
import "./DemandForecastingTop.vue?vue&type=style&index=1&id=0865bd90&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0865bd90"]])

export default __exports__